import { createFileRoute } from '@tanstack/react-router';
import { MySchedulePage } from '@/features/shifts/pages/my-schedule-page';

export const Route = createFileRoute('/_app/me/schedule')({ component: MySchedulePage });
